import styled from 'vue-styled-components';

export const Wrapper = styled.div`
  display: grid;
  width: 100%;
  margin-top: 2rem;

  .pagination {
    justify-self: end;
  }
`;
